<template>
    <g id="scroll-to-explore">
        <g id="arrow">
            <path id="arrow-line" class="arrow" :d="arrowPath.line" stroke="white"></path>
            <path id="arrow-chevron" class="arrow" :d="arrowPath.chevron" stroke="white"></path>
        </g>
        <text
            id="scroll-text"
            class="scroll-text"
            x="42"
            :y="arrow.bottom - 2"
            font-family="Alegreya"
            font-weight="300"
            fill="white"
        >Scroll to explore</text>
    </g>
</template>

<script>
import { mapState } from 'vuex'
import { styler, timeline } from 'popmotion'

import updateOnScroll from 'uos'
import { sceneData } from '@/util/sceneMap'

const THRESHOLD = 0.2

export default {
    data() {
        return {
            rootStyler: null,
            arrowStyler: null,
            arrowPathStyler: null,
            arrowChevronStyler: null,
            textStyler: null,
            progress: 0
        }
    },

    computed: {
        ...mapState(['w', 'h', 'scene']),

        isIntroScene: vm => vm.scene === 'intro',

        arrow() {
            return {
                top: this.h / 2 - ((this.h / 2) % 100),
                // bottom: this.h - 20 - ((this.h - 20) % 100),
                bottom: this.h - 10,
                left: 20,
                right: 40
            }
        },

        arrowPath() {
            return {
                line: `M${this.arrow.left} ${this.arrow.top} L ${
                    this.arrow.left
                } ${this.arrow.bottom}`,
                chevron: `M ${this.arrow.left - 10} ${this.arrow.bottom -
                    10} l 10 10 l 10 -10`
            }
        }
    },

    watch: {
        isIntroScene(isit) {
            if (isit) {
                this.show()
                this.enter()
            } else {
                this.hide()
            }
        },

        progress(p, oldP) {
            if (p >= THRESHOLD && oldP < THRESHOLD) {
                this.exit()
            } else if ((p < THRESHOLD) & (oldP >= THRESHOLD)) {
                this.enter()
            }
        }
    },

    mounted() {
        let [start, end] = sceneData.intro.scrollProgress
        this.uos = updateOnScroll(start, end, progress => {
            this.progress = progress
        })

        this.rootStyler = styler(this.$el)
        this.arrowStyler = styler(this.$el.querySelector('#arrow'))
        this.arrowPathStyler = styler(this.$el.querySelector('#arrow-line'))
        this.arrowChevronStyler = styler(
            this.$el.querySelector('#arrow-chevron')
        )
        this.textStyler = styler(this.$el.querySelector('#scroll-text'))

        if (!this.isIntroScene) {
            this.hide()
        }
    },

    methods: {
        show() {
            this.rootStyler.set({ opacity: 1 })
        },
        hide() {
            this.rootStyler.set({ opacity: 0 })
        },
        enter() {
            timeline([
                {
                    track: 'arrow',
                    from: { opacity: 0, y: -this.h / 2 },
                    to: { opacity: 1, y: 0 },
                    duration: 600
                },
                '-300',
                {
                    track: 'text',
                    form: { opacity: 0 },
                    to: { opacity: 1 },
                    duration: 600
                }
            ]).start(values => {
                this.arrowStyler.set(values.arrow)
                this.textStyler.set(values.text)
            })
        },
        exit() {
            timeline([
                {
                    track: 'arrow',
                    from: { opacity: 1, y: 0 },
                    to: { opacity: 0, y: -this.h / 2 }
                },
                { track: 'text', form: { opacity: 1 }, to: { opacity: 0 } }
            ]).start(values => {
                this.arrowStyler.set(values.arrow)
                this.textStyler.set(values.text)
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.arrow
    stroke-width: 2

    @media (min-width: 768px)
        stroke-width: 4

.scroll-text
    font-size: 24px

    @media (min-width: 768px)
        font-size: 32px
</style>

